import {useEffect, useState} from "react";
import {Api} from "laravel-request";
import {UserDefaultConfigConstants} from "#app/contexts/UserDefaultConfigConstants";

type rawConfigData = { id?: number, key: string, value: any }[]

export const useUserConfig = (initialConfig: rawConfigData = [], callback?: () => void) => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [config, setConfigState] = useState<rawConfigData>([])
    const [refresh, setRefresh] = useState(false)

    useEffect(() => {

        if (initialConfig.length > 0) {
            setConfigState(initialConfig)
            setRefresh(true)
            setIsLoaded(true)
        } else {
            setConfigState(Object.keys(UserDefaultConfigConstants).map((key) => {
                return {
                    key: key,
                    value: Object(UserDefaultConfigConstants)[key],
                }
            }))

            setRefresh(true)
            setIsLoaded(true)
        }
    }, [initialConfig.length])

    useEffect(() => {
        if (refresh)
            setRefresh(false)
    }, [refresh])

    const getConfByKeyJson = (key: keyof typeof UserDefaultConfigConstants) =>
    {
        let value = getConfByKey(key);

        if(value && typeof value === 'string')
        {
            return JSON.parse(value);
        }
    }

    const getConfByKey = (key: keyof typeof UserDefaultConfigConstants) => {

        let conf = config.filter((conf) => {
            return conf.key === key
        })

        if (conf.length > 0) {

            let dbValue = conf[0].value

            let normalizedData: string | number | null


            switch (typeof UserDefaultConfigConstants[key]) {
                case "object":

                    //@ts-ignore
                    if (UserDefaultConfigConstants?.[key] === 0) {
                        normalizedData = dbValue
                    } else {
                        normalizedData = (typeof dbValue === 'string' ? JSON.parse(String(dbValue)) : dbValue)
                    }
                    break
                case "number":
                    normalizedData = parseInt(dbValue)
                    break
                case "string":
                    normalizedData = String(dbValue)
                    break
                default:
                    normalizedData = dbValue
            }

            return normalizedData
        }

        return UserDefaultConfigConstants[key]
    }

    const setConfig = (key: keyof typeof UserDefaultConfigConstants, newValue: typeof UserDefaultConfigConstants, savedCallback?: (res: any) => void) => {

        let conf = config.filter((conf) => {
            return conf.key === key
        })


        let valueToSave: string
        switch (typeof newValue) {
            case "object":
                valueToSave = JSON.stringify(newValue)
                break
            default:
                valueToSave = String(newValue)
        }

        let data = {
            key: key,
            value: valueToSave,
        }

        if (conf.length > 0 && conf[0].id)
        {
            let api = Api.putArg('config', 'update', conf[0].id, data)
                .withoutNotify()
                //@ts-ignore
                .call((res) => {
                    let rec = {
                        id: res.meta.id,
                        key: key,
                        value: newValue
                    }
                    let newValues = config.filter((i) => i.id !== rec.id)
                    setConfigState(newValues.concat([rec]))

                    savedCallback?.(res)

                    callback?.()
                })
        } else {

            let api = Api.post('config', 'store', data).withoutNotify()
                .call((res) => {
                    let rec = {
                        id: res.meta.id,
                        key: key,
                        value: newValue
                    }
                    let newValues = config.filter((i) => i.key !== rec.key)
                    setConfigState(newValues.concat([rec]))

                    savedCallback?.(res)

                    callback?.()
                })
        }

    }

    const setConfigBulk = (keyPairValues: {
        name: keyof typeof UserDefaultConfigConstants,
        value: any
    }[]) => {
        keyPairValues.map((el) => {
            setConfig(el.name, el.value)
        })
    }


    return {
        refresh,
        config,
        isLoaded,
        getConfByKey: getConfByKey,
        getConfByKeyJson: getConfByKeyJson,
        setConfig: setConfig,
        setConfigBulk: setConfigBulk
    }
}
